//TODO
// toggle Edit button
//Form update => new type of form
// after submit, - error new form


import React, { Component } from 'react';
import {connect} from 'react-redux';
import { Form, Field} from 'react-final-form';

// A. Import components
import { CardFormSmall } from '../../widgets/Cards';
import { editOtherDetail, newOtherDetail, fetchOtherDetails } from '../../../actions';


// B. Class Development

class PatientDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            current_entry : null
        };
    };

    componentDidMount() {
        this.props.fetchOtherDetails(this.props.patient._id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.patient._id !== prevProps.patient._id) {
                this.props.fetchOtherDetails(this.props.patient._id)
        }    
    }

    formButton() {
        var permit = this.props.selectedPermission.permission[0].general;
        if (permit === "View only") {
            return "inaction";
        } else { 
            return "action";
        }  
    }
    
//B1. Handle Submit
    OtherDetailForm() { 
        const all_contents = this.props.content;
        const last_entry = all_contents[(all_contents.length)-1];
        const content = last_entry;

        const handleSubmit = (formValues) => {
            const form = formValues;
            console.log(form);

        // Change Actions below
            this.props.newOtherDetail(form);
        }

        const required = value =>(value ? undefined : 'Required');

        return (
            <Form
                onSubmit = {handleSubmit}
                initialValues = {content}
                render = {({handleSubmit, pristine, form, values, submitting}) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <div className='header'>Other Details</div>

                            <div className='form-container'>
                    
                                <Field name='language' component='input' validate={required} placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Language</label>
                                            <input {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                            
                                <Field name="interpreter" component='input'>
                                    {({ input}) => (
                                        <div>
                                            <label>State</label>
                                            <select {...input}>
                                                <option value="Not Required">Not Required</option>
                                                <option value="Required">Required</option>
                                            </select>
                                        </div>
                                )}
                                </Field>
                                <Field name='communication' component='input' validate={required} placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Communication</label>
                                            <input {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='cultural' component='input' validate={required} placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Cultural</label>
                                            <input {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='emergency' component='input' validate={required} placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Emergency Contacts</label>
                                            <input {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='mpoa' component='input' validate={required} placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Medical Power of Attorney</label>
                                            <input {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='directive' component='input' validate={required} placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Advanced Directive</label>
                                            <input {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                                <Field name='housing' component='input' validate={required} placeholder=''>
                                    {({input, meta, placeholder}) => (
                                        <div className={meta.active ? 'active':''}>
                                            <label>Accomodation Type</label>
                                            <input {...input} placeholder={placeholder} />
                                            {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                        </div>
                                    )} 
                                </Field>
                            </div>

                            <div className={this.formButton()}>
                                <button type='submit' disabled={submitting || pristine} className='btnew'>Submit</button>
                                <button type='button' onClick={form.reset} disabled={submitting || pristine } className='btdel'>Reset</button>
                                <button onClick={() => this.setState({showModal: false, record: null})} className='btdel'>Cancel</button>
                            </div>
                        </form>
                    )
                }}
            />
        )
    }

    render() {
        return (
            <CardFormSmall content={this.OtherDetailForm()}>
            </CardFormSmall>
        )
    }
}


const mapStateToProps = (state) => {

    return { 
             patient : state.selectedPatient,
             content : Object.values(state.otherdetails),
             userId : state.auth.userId,
             selectedPermission : state.selectedPermission,
            };
}

export default connect(mapStateToProps,{editOtherDetail, newOtherDetail, fetchOtherDetails})(PatientDetail);
